// Display helpers for the per-row timestamps that replaced registry version numbers
// (docs/tools-catalog-design.md, "Timestamps, not registry versions").

const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["year", 365 * 24 * 3600],
  ["month", 30 * 24 * 3600],
  ["week", 7 * 24 * 3600],
  ["day", 24 * 3600],
  ["hour", 3600],
  ["minute", 60],
];
const RELATIVE = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });

/** "2 days ago", "just now"; "never" for no timestamp. */
export function ago(iso: string | null | undefined): string {
  if (!iso) return "never";
  const seconds = (new Date(iso).getTime() - Date.now()) / 1000;
  for (const [unit, size] of UNITS) {
    if (Math.abs(seconds) >= size) return RELATIVE.format(Math.round(seconds / size), unit);
  }
  return "just now";
}

/** "updated 2 days ago", with the exact time for a tooltip. */
export function updatedLabel(iso: string | null | undefined): { text: string; title: string } {
  return { text: `updated ${ago(iso)}`, title: iso ? new Date(iso).toLocaleString() : "" };
}
